import { FunctionComponent } from "react";
import Highlighter from "react-highlight-words";
import { HIGHLIGHT_PROPS } from "components/company/CompanyTable/CompanyName/constants";
import useCompanyIdProps from "components/company/CompanyTable/CompanyId/useCompanyIdProps";

export interface CompanyIdProps {
  id?: string;
}

const CompanyId: FunctionComponent<CompanyIdProps> = function ({ id }) {
  const searchWords = useCompanyIdProps();

  return (
    <div className="flex flex-col text-16-20 text-neutral-900">
      <Highlighter
        {...HIGHLIGHT_PROPS}
        searchWords={searchWords}
        textToHighlight={id || ""}
      />
    </div>
  );
};

export default CompanyId;
